import { colors } from '../../colors';
var address = {
  arrowColor: colors.petsuitesPurple,
  textColor: colors.graphite,
  borderColor: colors.graphite,
  backgroundColor: colors.white
};
export default address;